import { jsx as _jsx } from "react/jsx-runtime";
import { AssetStatusType } from '@design-stack-vista/vista-assets-sdk';
import { css, cx } from '@emotion/css';
import { observer } from 'mobx-react-lite';
import { useLocalization } from '../../../../Localization';
import { useDrawerData } from '../../DrawerProvider';
import { getNumPages } from '../../utils';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
import { Icon } from '@vp/swan';
const inUseCheckboxStyle = css `
    position: absolute;
    bottom: 4px;
    right: 4px;
    max-width: 26px;
    max-height: 26px;
    width: 28%;
    height: 28%;
    border-radius: 100%;
    background-color: black;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const DrawerThumbnailInUseIcon = observer((props) => {
    const { isMultiboxThumbnail } = props;
    const { asset, asset: { status, isPresigned }, pageNumber, } = useDrawerThumbnailAsset();
    const { isAssetUsed } = useDrawerData();
    const { assetInUseLabel } = useLocalization();
    const areAnyPagesUsed = () => {
        const numPages = getNumPages(asset);
        return [...Array(numPages)].some((_, index) => isAssetUsed(asset, index + 1));
    };
    const showCheckIcon = isMultiboxThumbnail ? areAnyPagesUsed() : isAssetUsed(asset, pageNumber);
    if (!showCheckIcon) {
        return null;
    }
    if (status.type !== AssetStatusType.Prepared || !isPresigned) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: cx('drawer-thumbnail-button-check-mark', inUseCheckboxStyle) }, { children: _jsx(Icon, { title: assetInUseLabel, iconType: "check", skin: "white", margin: 0, size: "16p" }) })));
});
DrawerThumbnailInUseIcon.displayName = 'DrawerThumbnailInUseIcon';
//# sourceMappingURL=DrawerThumbnailInUseIcon.js.map